export const FEATURE_LIST_LOCAL_STORAGE = 'featureList'
export const FEATURE_LIST_HEADER = 'x-feature-list'

/**
 *
 *
 * /!\ DO NOT ADD FEATURE FLAGS HERE.
 *
 *    ADD TO FEATURE_FLAGS REPO.
 *
 */
